export const paaasSsh = [
  {
    item_nombre: "Programa Anual de Adquisiciones, Arrendamientos y Servicios",
    item_url: "../contenido/transparencia/paaas/Programa Anual de Adquisiciones 2025 SSH.pdf",
    item_descripcion: "Ejercicio Fiscal 2025"
  },
  {
    item_nombre: "Programa Anual de Adquisiciones, Arrendamientos y Servicios",
    item_url: "../contenido/transparencia/paaas/Programa Anual de Adquisiciones 2024 SSH.pdf",
    item_descripcion: "Ejercicio Fiscal 2024"
  },
  {
    item_nombre: "Programa Anual de Adquisiciones, Arrendamientos y Servicios",
    item_url: "../contenido/transparencia/paaas/Programa Anual de Adquisiciones 2022 SSH.pdf",
    item_descripcion: "Ejercicio Fiscal 2022"
  },
  {
    item_nombre: "Programa Anual de Adquisiciones, Arrendamientos y Servicios",
    item_url: "../contenido/transparencia/paaas/PAAAS 2021ssh.pdf",
    item_descripcion: "Ejercicio Fiscal 2021"
  }
];